import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { SearchContent } from "../../types/Content";
import * as S from "../Styles/SearchContents.styles"
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import FullStarIcon from "../../assets/fullStarIcon.png";
import { formatDate } from "../../utils/formatData";
import { formatKorean, formatUrl } from "../../utils/formatContentType";

interface Props {
    contents?: SearchContent[];
    totalElements?: number;
    emptyMessage: string;
}

function SearchContentList({ contents, totalElements = 0, emptyMessage }: Props) {

    const navigate = useNavigate();

    const RatingFullIcon = () => (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="#FFD600" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1.6l2.02 4.09 4.51.66-3.26 3.18.77 4.5L8 11.13l-4.04 2.13.77-4.5-3.26-3.18 4.51-.66L8 1.6z" />
        </svg>
    )

    const handleKeywordClick = (contentType: string, name: string) => {
        const params = new URLSearchParams();

        params.append("contentType", formatUrl(contentType))
        params.append("keyword", name);


        navigate(`/search/keyword?${params}`)
    }

    return (
        <S.ContentSection>
            <S.ContentTotalCount>{totalElements}개의 작품</S.ContentTotalCount>
            <S.ContentSearchList>
                {totalElements > 0 ? (
                    contents?.map((content) => (
                        <S.ContentSearchListItem>
                            <S.ContentSearchWrapper>
                                <S.ContentSearchItemCoverSection>
                                    <S.ContentCoverWrapper>
                                        <S.ContentCoverImage src={content.cover} alt={content.contentTitle} />
                                    </S.ContentCoverWrapper>
                                </S.ContentSearchItemCoverSection>
                                <S.ContentSearchItemInfoSection>
                                    <S.ContentInfoWrapper>
                                        <S.ContentTitleWrapper>
                                            <S.ContentTitle to={`/${formatUrl(content.contentType)}/${content.contentId}`}>{content.contentTitle}</S.ContentTitle>
                                        </S.ContentTitleWrapper>
                                        <S.ContentAuthorWrapper>
                                            <S.ContentAuthor>{content.author}</S.ContentAuthor>
                                            <S.ContentSeparate>ㆍ</S.ContentSeparate>
                                            <S.ContentType>{formatKorean(content.contentType)}</S.ContentType>
                                        </S.ContentAuthorWrapper>
                                        <S.EpisodeInfoContainer>
                                            <S.ContentEpisodeCount>총 {content.episodeCount}화</S.ContentEpisodeCount>
                                            <S.ContentSeparate>ㆍ</S.ContentSeparate>
                                            <S.ContentEpisodeUpdatedAt>{formatDate(content.episodeUpdatedAt)}</S.ContentEpisodeUpdatedAt>
                                        </S.EpisodeInfoContainer>
                                        <S.ContentRatingContainer>
                                            <S.ContentRatingStarIcon src={FullStarIcon} />
                                            <S.ContentRatingScore>{Number(content.totalAverageRating ?? 0).toFixed(1)}</S.ContentRatingScore>
                                            <S.ContentRatingCount>({content.totalRatingCount ?? 0})</S.ContentRatingCount>
                                        </S.ContentRatingContainer>
                                        <S.ContentDescriptionLink to={`/${formatUrl(content.contentType)}/${content.contentId}`}>
                                            <S.ContentDescription>{content.description}</S.ContentDescription>
                                        </S.ContentDescriptionLink>
                                        <S.ContentKeywordContainer>
                                            {content.keywords.map((keyword, index) => (
                                                <S.ContentKeywordItem key={index} onClick={() => handleKeywordClick(`${content.contentType}`, `${keyword.keyword}`)}>#{keyword.keyword}</S.ContentKeywordItem>
                                            ))}
                                        </S.ContentKeywordContainer>
                                    </S.ContentInfoWrapper>
                                </S.ContentSearchItemInfoSection>
                            </S.ContentSearchWrapper>
                        </S.ContentSearchListItem>
                    ))
                ) : (
                    <S.NoResultsWrapper>
                        <S.NoResultsText>
                            {emptyMessage}
                        </S.NoResultsText>
                    </S.NoResultsWrapper>

                )

                }
            </S.ContentSearchList>
        </S.ContentSection>
    )
}

export default SearchContentList;